(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("b8ZTd", function(module, exports) {

(parcelRequire("kI8SP")).register(JSON.parse('{"m0Fem":"index.3b38cf07.js","hoVUt":"lunr.4662f3e6.js"}'));

});
parcelRequire.register("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = {};
function $f13ecebb1f16f955$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f13ecebb1f16f955$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});


parcelRequire.register("9G6tZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kI8SP")).resolve("hoVUt")).then(()=>parcelRequire("4yeB3"));

});



parcelRequire("b8ZTd");
})();
(function() {
    let lunrLib = null;
    async function getLunr() {
        if (!lunrLib) {
            // chargé à la demande : Parcel en fait un bundle séparé (≈172 Ko)
            const mod = await parcelRequire94c2("9G6tZ");
            lunrLib = mod.default || mod.lunr || window.lunr;
        }
        return lunrLib;
    }
    async function initLunr() {
        const lunr = await getLunr();
        const searchResponse = await fetch("/search.json");
        const searchJson = await searchResponse.json();
        return lunr.Index.load(searchJson);
    }
    let idx = null;
    let pages_lookup = null;
    async function getPageLookup() {
        const mapResponse = await fetch("/sitemap.json");
        const mapJson = await mapResponse.json();
        return mapJson.pages;
    }
    const SEARCH_MAX_RES = 10;
    async function handleSearchSubmit(event) {
        event.preventDefault();
        const searchTerm = document.querySelector('.search-panel  input[name="q"]').value;
        if (!idx) idx = await initLunr();
        if (!pages_lookup) pages_lookup = await getPageLookup();
        const results = idx.search(searchTerm);
        results.splice(SEARCH_MAX_RES);
        // cleaning .search-results (empty div) and displaying all results inside (creating ul / li) .
        const searchResults = document.querySelector(".search-results");
        searchResults.innerHTML = "";
        const ul = document.createElement("ul");
        searchResults.appendChild(ul);
        results.forEach((result)=>{
            const li = document.createElement("li");
            const a = document.createElement("a");
            // if doesnt start with trailing slash, add it
            a.href = (result.ref[0] === "/" ? "" : "/") + result.ref;
            const corresponding_page = pages_lookup.find((p)=>p.href === result.ref);
            if (!corresponding_page) {
                console.log("no corresponding page for " + result.ref);
                return;
            }
            a.textContent = corresponding_page.breadcrumb || corresponding_page.formated_title; // + ' (' + result.score + ')';
            li.appendChild(a);
            ul.appendChild(li);
        });
    }
    window.addEventListener("load", ()=>{
        document.querySelector(".search-panel form").onsubmit = handleSearchSubmit;
        document.querySelector("#search-icon").onclick = handleSearchSubmit;
    });
})();

//# sourceMappingURL=index.3b38cf07.js.map
